// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/TokenEarning/TokenCard.css
// module id = 2530
// module chunks = 0